import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class DocumentMetaConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getAlternateSeoTagEnabled(): boolean {
		return this.config.get((x) => x.core.documentMeta.alternateSeoTagEnabled, false);
	}

	getAlternativeUrlsEnabled(): boolean {
		return this.config.get((x) => x.core.documentMeta.alternativeUrlsEnabled, true);
	}

	getExternalHreflang(): { [key: string]: string } {
		return this.config.get((x) => x.core.documentMeta.externalHreflang, {});
	}

	getCustomAlternativeUrls() {
		return this.config.get((x) => x.core.documentMeta.customAlternativeUrls, undefined);
	}

	getCustomMetaTags() {
		return this.config.get((x) => x.core.documentMeta.customMetaTags, []);
	}

	getExternalBrands() {
		return this.config.get((x) => x.core.documentMeta.externalBrands, []);
	}
}
